import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { computed, toRef } from "vue";
import { useI18n } from "vue-i18n";
import { buildRemoveChipLabel } from "@/shared/composables/removeChipLabel";
import { AutoComplete, DatePickerInput, EmailInput, ImageUploadInput, MultipleSelect, PhoneInput, SelectInput, Textarea, TextInput, UrlInput, } from "@eudonet/opal";
import { useFieldVisibility } from "@/shared/composables/useFieldVisibility";
import { logger } from "@/infrastructure/services/LoggerService";
// CheckboxInput is not yet used in Organisation.vue but is part of the FieldType spec.
// Import it separately when it becomes available in the OPAL package.
// import { CheckboxInput } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldResolver',
    props: {
        field: {},
        blockValues: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const blockValuesRef = toRef(props, "blockValues");
        const { isVisible } = useFieldVisibility(props.field.rules, blockValuesRef);
        const normalizedType = computed(() => props.field.type.toLowerCase());
        const componentMap = {
            text: TextInput,
            number: TextInput,
            textarea: Textarea,
            url: UrlInput,
            email: EmailInput,
            date: DatePickerInput,
            select: SelectInput,
            multiselect: MultipleSelect,
            autocomplete: AutoComplete,
            phone: PhoneInput,
            "image-upload": ImageUploadInput,
            // boolean: CheckboxInput,
        };
        const resolvedComponent = computed(() => {
            const component = componentMap[normalizedType.value];
            if (!component && import.meta.env.DEV) {
                logger.debug(`[FieldResolver] No component mapped for field type "${props.field.type}". Field will not render.`);
            }
            return component;
        });
        // TextInput expects a string modelValue and calls .trim() internally.
        // Convert numbers and other primitives to string to avoid runtime errors.
        const normalizedValue = computed(() => {
            const v = props.field.value;
            if (normalizedType.value === "number")
                return v != null ? String(v) : "";
            return v;
        });
        // Reverse normalization: number fields emit strings from TextInput; convert back.
        function onUpdate(raw) {
            if (normalizedType.value === "number") {
                const s = raw;
                emit("update:modelValue", s === "" ? null : Number(s));
            }
            else {
                emit("update:modelValue", raw);
            }
        }
        const extraProps = computed(() => {
            const result = {};
            const { config } = props.field;
            const type = normalizedType.value;
            if (config?.placeholder) {
                result.placeholder = config.placeholder;
            }
            if (config?.options && (type === "select" || type === "multiselect")) {
                result.options = config.options.map((opt) => ({ ...opt, label: t(opt.label) }));
            }
            if (type === "multiselect") {
                result.removeChipLabel = buildRemoveChipLabel(t);
            }
            if (type === "number") {
                result.type = "number";
                if (config?.min !== undefined)
                    result.min = config.min;
                if (config?.max !== undefined)
                    result.max = config.max;
            }
            return result;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(normalizedType.value === 'textarea' ? 'col-span-2' : 'col-span-2 md:col-span-1')
            }, [
                (_unref(isVisible))
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(resolvedComponent.value), _mergeProps({
                        key: 0,
                        "model-value": normalizedValue.value,
                        label: _unref(t)(__props.field.label),
                        disabled: __props.field.rules.readonly,
                        required: __props.field.rules.required
                    }, extraProps.value, {
                        "full-width": "",
                        "onUpdate:modelValue": onUpdate
                    }), null, 16 /* FULL_PROPS */, ["model-value", "label", "disabled", "required"]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
